import type { WidgetId } from '../../hooks/useDashboardLayout';

export const WIDGET_SIZE_CLASSES: Record<WidgetId, string> = {
  'kpi-active-skus': 'col-span-12 sm:col-span-6 lg:col-span-3',
  'kpi-fba-units': 'col-span-12 sm:col-span-6 lg:col-span-3',
  'kpi-inbound': 'col-span-12 sm:col-span-6 lg:col-span-3',
  'kpi-on-order': 'col-span-12 sm:col-span-6 lg:col-span-3',
  'kpi-revenue': 'col-span-12 sm:col-span-6 lg:col-span-3',
  'kpi-profit': 'col-span-12 sm:col-span-6 lg:col-span-3',
  'kpi-roi': 'col-span-12 sm:col-span-6 lg:col-span-3',
  'inventory-overview': 'col-span-12 lg:col-span-6',
  'financial-summary': 'col-span-12 lg:col-span-6',
  'revenue-chart': 'col-span-12',
  'sales': 'col-span-12 lg:col-span-6',
  'top-products': 'col-span-12 lg:col-span-6',
  'inventory-health': 'col-span-12 lg:col-span-6',
  'next-actions': 'col-span-12 lg:col-span-6',
  'restock-alerts': 'col-span-12 lg:col-span-6',
  'purchase-orders': 'col-span-12 lg:col-span-6',
  'supplier-restock': 'col-span-12 lg:col-span-6',
  'restock-list': 'col-span-12 lg:col-span-6',
  'setup-focus': 'col-span-12 lg:col-span-6',
  'system-alerts': 'col-span-12 lg:col-span-6',
};

export const WIDGET_COL_SPAN: Record<WidgetId, number> = {
  'kpi-active-skus': 3,
  'kpi-fba-units': 3,
  'kpi-inbound': 3,
  'kpi-on-order': 3,
  'kpi-revenue': 3,
  'kpi-profit': 3,
  'kpi-roi': 3,
  'inventory-overview': 6,
  'financial-summary': 6,
  'revenue-chart': 12,
  'sales': 6,
  'top-products': 6,
  'inventory-health': 6,
  'next-actions': 6,
  'restock-alerts': 6,
  'purchase-orders': 6,
  'supplier-restock': 6,
  'restock-list': 6,
  'setup-focus': 6,
  'system-alerts': 6,
};

export const WIDGET_ROW_SPAN: Record<WidgetId, number> = {
  'kpi-active-skus': 1,
  'kpi-fba-units': 1,
  'kpi-inbound': 1,
  'kpi-on-order': 1,
  'kpi-revenue': 1,
  'kpi-profit': 1,
  'kpi-roi': 1,
  'inventory-overview': 2,
  'financial-summary': 2,
  'revenue-chart': 2,
  'sales': 2,
  'top-products': 4,
  'inventory-health': 2,
  'next-actions': 2,
  'restock-alerts': 2,
  'purchase-orders': 2,
  'supplier-restock': 2,
  'restock-list': 4,
  'setup-focus': 2,
  'system-alerts': 2,
};

export const WIDGET_LABELS: Record<WidgetId, string> = {
  'kpi-active-skus': 'Active SKUs',
  'kpi-fba-units': 'FBA Units',
  'kpi-inbound': 'Inbound',
  'kpi-on-order': 'On Order',
  'kpi-revenue': 'Gross Sales',
  'kpi-profit': 'Profit',
  'kpi-roi': 'ROI',
  'inventory-overview': 'Inventory Overview',
  'financial-summary': 'Financial Summary',
  'revenue-chart': 'Revenue & Profit',
  'sales': 'Sales Summary',
  'top-products': 'Top Products',
  'inventory-health': 'Inventory Health',
  'next-actions': 'Next Actions',
  'restock-alerts': 'Restock Alerts',
  'purchase-orders': 'Purchase Orders',
  'supplier-restock': 'Supplier Restock',
  'restock-list': 'Restock List',
  'setup-focus': 'Operational Readiness',
  'system-alerts': 'System Alerts',
};

export const WIDGET_MENU_SECTIONS: { label: string; ids: WidgetId[] }[] = [
  {
    label: 'Overview',
    ids: ['inventory-overview', 'financial-summary'],
  },
  {
    label: 'Individual KPIs',
    ids: [
      'kpi-active-skus',
      'kpi-fba-units',
      'kpi-inbound',
      'kpi-on-order',
      'kpi-revenue',
      'kpi-profit',
      'kpi-roi',
    ],
  },
  {
    label: 'Charts & Lists',
    ids: [
      'revenue-chart',
      'sales',
      'top-products',
      'inventory-health',
      'restock-alerts',
      'purchase-orders',
      'supplier-restock',
      'restock-list',
    ],
  },
  {
    label: 'Setup & Alerts',
    ids: [
      'next-actions',
      'setup-focus',
      'system-alerts',
    ],
  },
];
